module.exports = {
    message: 'This message arrive from config/config.js',
    loggerComponentName: 'rcs_tag-manager',
};
